import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DPProduct } from './model/dp-product';
import { DPSubscriptionService } from './dp-subscriptions.service';
import { DPAccountService } from './dp-accounts.service';
import { DPAccount } from './dp-account';
import { DPModule } from './model/dp-module';
import { DPModuleConfig } from './model/dp-module-config';

import { DPSubscriptionRequest } from './model/dp-subscriptionRequest';
import { NotificationsService, SimpleNotificationsComponent } from 'angular2-notifications';
import { ToasterService } from 'angular2-toaster/src/toaster.service';


@Component({
    selector: 'my-module-create',
    templateUrl: 'dp-module-create.component.html'
})
export class DPModuleCreateComponent implements OnInit {
    @Input() module: DPModule;
    @Output() close = new EventEmitter();
    errorResponse: any;
    navigated = true; // true if navigated here
    success: any;
    products: DPProduct[];
    filteredProducts: DPProduct[];
    selectedProduct: DPProduct;
    notificationTitle: any;
    notificationContent: any;
    notificationType: any;
    enableValue = false;
    submitting = false;
    accountId: number;
    configs: DPModuleConfig[];
    moduleConfig: DPModuleConfig;
    inputvalue: string;
    dpModules: DPModule[];
    subcriptionTypeSpec = 'carryover';
    subscriptionType = 'Monthly (Carry Over)';

    constructor(
        private toasterService: ToasterService,

        private _service: NotificationsService,
        private router: Router,
        private subscriptionService: DPSubscriptionService,
        private route: ActivatedRoute) {
    }
    public options = {
        timeOut: 5000,
        lastOnBottom: true,
        clickToClose: true,
        maxLength: 0,
        maxStack: 7,
        showProgressBar: true,
        pauseOnHover: true,
        preventDuplicates: false,
        preventLastDuplicates: 'visible',
        rtl: false,
        animate: 'scale',
        position: ['right', 'bottom']
    };


    createNotification() {
        switch (this.notificationType) {
            case 'success':
                //this._service.success(this.notificationTitle, this.notificationContent);
                this.toasterService.pop('success', this.notificationTitle, this.notificationContent);
                break;
            case 'error':
                this.toasterService.pop('error', this.notificationTitle, this.notificationContent);
                //this._service.error(this.notificationTitle, this.notificationContent);
                break;
            case 'info':
                this.toasterService.pop('info', this.notificationTitle, this.notificationContent);
                //this._service.info(this.notificationTitle, this.notificationContent);
                break;
        }
    }

    errorHandler(error: any) {
        this.submitting = false;
        this.notificationType = 'error';
        this.notificationTitle = 'Error';

        const jsonErrorBody = JSON.parse(error._body);
        this.notificationContent = jsonErrorBody.error.message;

        this.createNotification();
    }
    getProducts() {
        return this.subscriptionService
            .getProducts()
            .then(res => {
                this.products = res.subscriptions.modules;
                this.filteredProducts = this.products;
                this.getSubscriptions(this.accountId);
            })
            .catch(error => this.errorHandler(error));
    }

    getSubscriptions(account_id: number) {

        return this.subscriptionService
            .getSubscriptions(account_id)
            .then(res => {
                this.dpModules = res.subscriptions.modules;
                this.dpModules.forEach(dpmodule => this.filteredProducts = this.filteredProducts.filter(u => u.product_offering_id !== dpmodule.product.product_offering_id));
            })
            .catch(error => {
                this.errorHandler(error);
            });
    }


    ngOnInit() {

        this.route.params.forEach((params: Params) => {
            const account_id = +params['account_id'];
            this.accountId = account_id;
            this.module = new DPModule();
            this.navigated = true;
            this.getProducts();

        });


    }
    save1(module: DPModule, isValid: boolean) {
        this.submitting = true;

        if (this.selectedProduct.product_offering_id == 1) {
            this.configs[5].specification_value = this.subcriptionTypeSpec;
        }

        const emptyValue = this.configs.find(c => (c.specification_value !== undefined ? c.specification_value.toString() : undefined) === '');

        if (emptyValue == undefined) {
            this.module.product_id = this.selectedProduct.product_offering_id;
            this.module.account_id = this.accountId;
            this.module.configs = this.configs;
            this.save(this.module);

        } else {
            this.submitting = false;
            this.notificationType = 'error';
            this.notificationTitle = 'Error';
            this.notificationContent = 'Config values must be inserted';
            this.createNotification();
        }

    }

    save(moduleRequest: DPModule) {
        this.subscriptionService
            .addModule(moduleRequest, this.accountId)
            .then(user => {
                this.submitting = false;

                this.goBack();
            })
            .catch(error => {
                this.submitting = false;
                this.errorHandler(error);
            });
    }
    goBack() {
        if (this.navigated) {
            event.stopPropagation();
            this.router.navigate(['/demandportal/customer/account/subscriptions', this.accountId]);

        }
    }

    selectProduct(product: DPProduct) {
        if (product.product_offering_id == 1 || product.product_offering_id == 2 || product.product_offering_id == 4) {
            this.enableValue = true;
        } else {
            this.enableValue = false;
        }
        this.selectedProduct = product;
        this.configs = new Array<DPModuleConfig>();
        if (product.product_offering_id == 1) {
            const demandTitle = new DPModuleConfig();
            demandTitle.specification_name = 'titles';
            demandTitle.specification_value = '';
            this.configs.push(demandTitle);

            const demandMarket = new DPModuleConfig();
            demandMarket.specification_name = 'markets';
            demandMarket.specification_value = '';
            this.configs.push(demandMarket);

            const demandUsers = new DPModuleConfig();
            demandUsers.specification_name = 'users';
            demandUsers.specification_value = '';
            this.configs.push(demandUsers);

            const demandHours = new DPModuleConfig();
            demandHours.specification_name = 'projecthours';
            demandHours.specification_value = '';
            this.configs.push(demandHours);

            const subscriptionLength = new DPModuleConfig();
            subscriptionLength.specification_name = 'subscriptionlength';
            subscriptionLength.specification_value = '';
            this.configs.push(subscriptionLength);

            const consultantType = new DPModuleConfig();
            consultantType.specification_name = 'consultanttype';
            consultantType.specification_value = '';
            this.configs.push(consultantType);

            const demandModules = new DPModuleConfig();
            demandModules.specification_name = 'modules';
            demandModules.specification_value = '';
            this.configs.push(demandModules);
        }

        else if (product.product_offering_id == 4) {
            const topTitle = new DPModuleConfig();
            topTitle.specification_name = 'titles';
            topTitle.specification_value = '';
            this.configs.push(topTitle);
        }
        else if (product.product_offering_id == 2) {
            const config = new DPModuleConfig();
            config.specification_name = 'start_date';
            config.specification_value = '';
            this.configs.push(config);
        } else if ([7,9,11,12,14,15,16].includes(product.product_offering_id)) {
            const config = new DPModuleConfig();
            config.specification_name = 'modules';
            config.specification_value = product.product_offering_id.toString();
            this.configs.push(config);
        }  else {
            const config = new DPModuleConfig();
            config.specification_name = 'modules';
            config.specification_value = product.product_offering_id.toString();
            this.configs.push(config);
        }

    }

    setConfigValues(index: number, value: string) {
        this.configs[index].specification_value = value;
    }
    setConfigSwitch(index: number) {
        if (this.configs[index].specification_value == 'true') {
            this.configs[index].specification_value = 'false';
        } else {
            this.configs[index].specification_value = 'true';
        }

    }

    clickViewType(event: any) {
        if (this.subscriptionType == 'Monthly (Carry Over)') {
            this.subcriptionTypeSpec = 'carryover';
        } else if (this.subscriptionType == 'Monthly (Non Carry Over)') {
            this.subcriptionTypeSpec = 'noncarryover';
        } else if (this.subscriptionType == 'Yearly') {
            this.subcriptionTypeSpec = 'yearly';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/portalv1/dp-module-create.component.ts